import { createStyles } from '@material-ui/core';
import { borderRadius, colorUsage, getSpacing } from 'stylesheet';
var MuiBorderGradientButtonOverrideGenerator = createStyles({
  root: {
    display: 'flex',
    padding: "".concat(getSpacing(1), " ").concat(getSpacing(2)),
    borderRadius: borderRadius.medium,
    color: function color(_ref) {
      var selected = _ref.selected;
      return selected ? colorUsage.borderGradientButtonHoverContent : colorUsage.textColor;
    },
    backgroundColor: colorUsage.muiOverride.shadowIcon.background,
    backgroundClip: 'padding-box',
    border: function border(_ref2) {
      var selected = _ref2.selected;
      return selected ? '2px solid transparent' : "2px solid ".concat(colorUsage.borderGradientButtonBorder);
    },
    transition: "border 0ms",
    textTransform: 'unset',
    width: '200px',
    height: '48px',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      margin: '-2px',
      borderRadius: 'inherit',
      zIndex: -1,
      background: function background(_ref3) {
        var selected = _ref3.selected;
        return selected ? colorUsage.buttonGradient : 'unset';
      }
    },
    '& path': {
      // `Props` has to be specified again because `createStyles` type definition does not handle well when using a function with SVG properties
      fill: function fill(_ref4) {
        var selected = _ref4.selected;
        return selected ? colorUsage.borderGradientButtonHoverContent : 'initial';
      }
    },
    '&:hover': {
      border: '2px solid transparent',
      backgroundColor: 'white',
      color: colorUsage.borderGradientButtonHoverContent,
      '&:before': {
        background: colorUsage.buttonGradient
      },
      '& path': {
        fill: colorUsage.borderGradientButtonHoverContent
      }
    }
  },
  label: {
    display: 'flex',
    justifyContent: function justifyContent(_ref5) {
      var centered = _ref5.centered;
      return centered === true ? 'center' : 'start';
    }
  },
  startIcon: {
    marginRight: 4
  }
});
export { MuiBorderGradientButtonOverrideGenerator };